import { api } from "../../gateways/unilabApi";

export async function getGeometry(payload) {
  var modality = payload.modality;
  var isSaldobrasata = payload.isSaldobrasata;
  return await api.get(`phe-geometry/modalities/${modality}/${isSaldobrasata}`);
}

export async function postRemove(payload) {
  return await api.post(`phe-geometry/destroy`, payload);
}
export async function postUploadList(payload) {
  return await api.post(`phe-geometry/updateAddAllExport`, payload);
}
export async function getListExport() {
  return await api.get(`phe-geometry/listExport`);
}
export async function getExportModel() {
  return await api.get(`phe-geometry/exportModel`);
}
export async function getMixedGeometryList(payload) {
  var mod = payload.modality;
  var isSaldobrasata = payload.isSaldobrasata;
  return await api.get(
    `phe-geometry/mixedGeometryList?mod=${mod}&isSaldobrasata=${isSaldobrasata}`
  );
}
